import { subtractDuration } from 'lib/flights/flightUtils'
import type { HiddenStopOverride } from './JourneyV2DetailsModalFlight'

export function constructHiddenStopSegmentOriginToStop(
  firstStop: App.HiddenStop,
  flight: App.FlightV2 | App.LegFlight,
  airports: Array<App.Airport>,
): HiddenStopOverride {
  const airportName = airports.find(a => a.code === firstStop.airportCode)?.name ?? firstStop.airportCode
  return {
    departureAirport: flight.departureAirport,
    departureAirportName: flight.departureAirportName,
    departingTime: flight.departingTime,
    departingDate: flight.departingDate,
    arrivalAirport: firstStop.airportCode,
    arrivalAirportName: airportName,
    arrivalTime: firstStop.arrivalTime,
    duration: firstStop.elapsedTime,
  }
}

// Unlikely to be used, but we assume that elapsed time in these cases is the duration since the departure of the the previous stop to the current stops arrival
export function constructHiddenStopSegmentStopToStop(
  fromStop: App.HiddenStop,
  toStop: App.HiddenStop,
  airports: Array<App.Airport>,
): HiddenStopOverride {
  const fromName = airports.find(a => a.code === fromStop.airportCode)?.name ?? fromStop.airportCode
  const toName = airports.find(a => a.code === toStop.airportCode)?.name ?? toStop.airportCode

  return {
    departureAirport: fromStop.airportCode,
    departureAirportName: fromName,
    departingTime: fromStop.departureTime,
    arrivalAirport: toStop.airportCode,
    arrivalAirportName: toName,
    arrivalTime: toStop.arrivalTime,
    duration: toStop.elapsedTime,
  }
}

export function constructHiddenStopSegmentStopToDestination(
  allStops: Array<App.HiddenStop>,
  flight: App.FlightV2 | App.LegFlight,
  airports: Array<App.Airport>,
): HiddenStopOverride {
  const lastStop = allStops[allStops.length - 1]
  const airportName = airports.find(a => a.code === lastStop.airportCode)?.name ?? lastStop.airportCode
  const flightTime = 'duration' in flight ? flight.duration : flight.flightTime
  const totalStopTime = allStops.reduce<{ hours: number; minutes: number }>(
    (acc, stop) => ({
      hours: acc.hours + stop.elapsedTime.hours + stop.elapsedLayoverTime.hours,
      minutes: acc.minutes + stop.elapsedTime.minutes + stop.elapsedLayoverTime.minutes,
    }),
    { hours: 0, minutes: 0 },
  )
  return {
    departureAirport: lastStop.airportCode,
    departureAirportName: airportName,
    departingTime: lastStop.departureTime,
    arrivalAirport: flight.arrivalAirport,
    arrivalAirportName: flight.arrivalAirportName,
    arrivalTime: flight.arrivalTime,
    arrivalDate: flight.arrivalDate,
    duration: subtractDuration(flightTime, totalStopTime),
  }
}
